var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "layer7",
  transform: "translate(-273.3,-436)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 286.6 555.5 v 23.2 h 5.9 v -6 l 5.4 5.4 h 9.1 l -7.2 -7.2 c 0 0 5.2 -0.1 5.6 -7.6 c 0 -6.9 -5.2 -7.8 -11.2 -7.8 H 286.6 z M 292.8 561.8 h 5.1 v 4.1 h -5.1 V 561.8 z",
  id: "path3993",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 318.3 555.6 c -3.2 0 -7.7 0.3 -7.7 6.4 v 16.1 h 6.1 v -3.9 h 5.9 v 3.8 h 6.1 v -16.9 c 0 -5.3 -5.9 -5.5 -9 -5.5 C 319.2 555.6 318.8 555.6 318.3 555.6 z M 316.8 561.4 h 5.7 v 6.3 h -5.7 V 561.4 z",
  id: "path3997",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("rect", {
  height: 22.2,
  id: "rect4001",
  width: 6.3,
  x: 334.7,
  y: 555.6,
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 347.6 555.9 v 22.2 h 15.1 v -5.9 h -8.9 v -16.4 L 347.6 555.9 z",
  id: "path4003",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 382.7 555.7 v 6 h -10.1 v 2.2 c 0 0 2.1 0 4.3 0 s 7 -0.1 7 7 c 0 7.1 -3.2 7.4 -9.8 7.4 c -6.6 0 -7.9 0 -7.9 0 v -5.4 c 0 0 6.4 0 9.1 0 s 2.9 -0.9 2.9 -1.7 s -1.4 -1.1 -4.3 -1.1 s -8.1 -1.4 -8.1 -6.9 c 0 -5.5 2.7 -7.5 8.2 -7.5 S 382.7 555.7 382.7 555.7 L 382.7 555.7 z",
  id: "path4005",
  fill: "#fa2700"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "layer6",
  transform: "matrix(1,0,0,1,-273.3,-436)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 292.1 548.9 h 52.1 c 0 0 -11.6 -26.3 -8.6 -50.4 c 2.9 -24.1 22 -35.1 32.7 -36.3 c 10.8 -1.2 16.7 5.5 16.7 5.5 l 2.4 -3.5 c 0 0 -15.5 -15.7 -35.1 -13.9 c -19.6 1.8 -33.1 14.7 -41.6 30.4 c -8.4 15.7 -13.3 26.7 -16.7 43.1 S 292.1 548.9 292.1 548.9 z",
  id: "path3966",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 281.7 522.7 l 10.2 0.8 l -1.8 10.2 l -9.6 -1.2 L 281.7 522.7 z",
  id: "path3968",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 297.8 501.1 l 2.7 -7.6 l -9 -3.5 l -2.9 8.2 L 297.8 501.1 z",
  id: "path3970",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 310.5 474.8 l 5.3 -6.3 l -6.9 -4.5 l -5.5 6.1 L 310.5 474.8 z",
  id: "path3972",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 324.4 450.5 l 4.7 5.7 l 6.5 -3.7 l -4.7 -5.3 L 324.4 450.5 z",
  id: "path3974",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 347.4 444.1 l 1.2 5.7 l 8 -0.2 l -0.8 -5.1 L 347.4 444.1 z",
  id: "path3976",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 374.6 450.1 l -0.2 3.5 l 5.5 2.9 l 1.2 -1.8 L 374.6 450.1 z",
  id: "path3978",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 373.4 465.2 v 2.9 l 5.3 0.6 v -2.4 L 373.4 465.2 z",
  id: "path3980",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 356.6 467.8 l 2.5 4.7 l 3.7 -2.9 l -0.8 -3.1 L 356.6 467.8 z",
  id: "path3982",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 348.6 473.9 l 3.9 5.9 l -2.4 4.1 l -5.7 -6.3 L 348.6 473.9 z",
  id: "path3984",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 340.7 490.1 l -2.5 5.1 l 6.7 5.7 l 1.6 -6.5 L 340.7 490.1 z",
  id: "path3986",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 338 508 l -0.4 6.9 l 8.2 3.5 l -0.4 -6.5 L 338 508 z",
  id: "path3988",
  fill: "#fa2700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 340.3 532.3 l 2 7.1 l 10.4 0.6 l -3.7 -7.6 H 340.3 z",
  id: "path3990",
  fill: "#fa2700"
}));
function SvgRedRubyOnRails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "157.6px",
    id: "svg3120",
    style: {
      enableBackground: "new 0 0 122.498 157.564"
    },
    viewBox: "0 0 122.498 157.564",
    width: "122.5px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedRubyOnRails);
export default __webpack_public_path__ + "static/media/red-ruby-on-rails.6ec91284afe12aeedaf816e70f8bcb1c.svg";
export { ForwardRef as ReactComponent };